import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title: string;
  description: string;
}

const MLBPlayImage = '';
const MLBPlayCreator = 'Major League Baseball';

export const SEO = ({ title, description }: SEOProps) => {
  return (
    <Helmet>
      <title>MLB Play | {title} | MLB.com</title>
      <meta name="description" content={description} />
      <meta name="image" content={MLBPlayImage} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={MLBPlayImage} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={MLBPlayCreator} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
};

export default SEO;
